/* ==========================================================================
   LAKSHIV ENTERPRISE — Product page
   Variant selection, media gallery, zoom, lightbox, recommendations.
   ========================================================================== */

(function () {
  'use strict';

  var L = (window.Lakshiv = window.Lakshiv || {});
  var utils = L.utils;
  if (!utils) return;

  /* --- Variant selection --------------------------------------------------- */

  function VariantPicker(container) {
    this.container = container;
    this.form = container.querySelector('form[action*="/cart/add"]');
    this.idInputs = utils.qsa('form[action*="/cart/add"] [name="id"]', container);

    var data = container.querySelector('[data-variant-json]');
    try {
      this.variants = data ? JSON.parse(data.textContent) : [];
    } catch (e) {
      this.variants = [];
    }

    if (!this.variants.length) return;

    this.updateUrl = container.getAttribute('data-update-url') !== 'false';
    this.bind();
    // Reflect availability for the initially selected options.
    this.updateOptionAvailability(this.selectedOptions());
  }

  VariantPicker.prototype.bind = function () {
    var self = this;
    this.container.addEventListener('change', function (event) {
      if (!event.target.matches('[data-variant-option]')) return;
      self.onChange();
    });
  };

  VariantPicker.prototype.selectedOptions = function () {
    return utils
      .qsa('[data-variant-option]:checked', this.container)
      .sort(function (a, b) {
        return (
          Number(a.getAttribute('data-option-position')) -
          Number(b.getAttribute('data-option-position'))
        );
      })
      .map(function (input) {
        return input.value;
      });
  };

  VariantPicker.prototype.findVariant = function (options) {
    return (
      this.variants.find(function (variant) {
        return variant.options.every(function (value, i) {
          return value === options[i];
        });
      }) || null
    );
  };

  VariantPicker.prototype.onChange = function () {
    var options = this.selectedOptions();
    var variant = this.findVariant(options);

    this.updateLabels();
    this.updateOptionAvailability(options);

    if (!variant) {
      this.setUnavailable();
      return;
    }

    this.current = variant;
    this.idInputs.forEach(function (input) {
      input.value = variant.id;
      input.disabled = !variant.available;
    });

    this.updatePrice(variant);
    this.updateMedia(variant);
    this.updateInventory(variant);
    this.updateButtons(variant);
    this.updateSku(variant);
    this.updateHistory(variant);

    this.container.dispatchEvent(
      new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } })
    );
  };

  /** Prints the chosen value beside each option name ("Colour: Charcoal"). */
  VariantPicker.prototype.updateLabels = function () {
    utils.qsa('[data-variant-option]:checked', this.container).forEach(function (input) {
      var group = input.closest('[data-option-group]');
      if (!group) return;
      var display = group.querySelector('[data-option-value]');
      if (display) display.textContent = input.value;
    });
  };

  /**
   * Marks option values that cannot be combined with the current selection.
   * Only the *other* options are held fixed, so a shopper can always switch
   * along one axis at a time — the pattern shoppers expect.
   */
  VariantPicker.prototype.updateOptionAvailability = function (selected) {
    var variants = this.variants;

    utils.qsa('[data-variant-option]', this.container).forEach(function (input) {
      var position = Number(input.getAttribute('data-option-position')) - 1;
      var candidate = selected.slice();
      candidate[position] = input.value;

      var match = variants.find(function (variant) {
        return variant.options.every(function (value, i) {
          if (i === position) return value === input.value;
          // Ignore option axes the shopper hasn't chosen yet.
          return candidate[i] == null || value === candidate[i];
        });
      });

      var available = !!(match && match.available);
      var wrapper = input.closest('.variant-option');
      if (wrapper) wrapper.classList.toggle('variant-option--unavailable', !available);
      input.setAttribute('aria-disabled', String(!available));
    });
  };

  VariantPicker.prototype.updatePrice = function (variant) {
    var target = this.container.querySelector('[data-price-block]');
    if (!target) return;

    var html =
      '<span class="price__current"><span data-base-price="' + variant.price + '">' + utils.formatMoney(variant.price) + '</span></span>';

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var saving = Math.round(
        ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
      );
      html +=
        '<s class="price__compare"><span data-base-price="' + variant.compare_at_price + '">' +
        utils.formatMoney(variant.compare_at_price) +
        '</span></s><span class="price__save">' +
        saving +
        '% OFF</span>';
      target.classList.add('price--sale');
    } else {
      target.classList.remove('price--sale');
    }

    target.innerHTML = html;

    // Update the business price only from the authoritative variant payload.
    var b2bPriceDisplay = document.querySelector('[data-b2b-price-display]');
    if (b2bPriceDisplay) {
      var b2bContainer = b2bPriceDisplay.closest('.b2b-product-details');
      var newWholesale = Number(variant.b2b_price) || variant.price;
      
      b2bPriceDisplay.setAttribute('data-base-price', newWholesale);
      b2bPriceDisplay.removeAttribute('data-currency-converted');
      b2bPriceDisplay.innerHTML = utils.formatMoney(newWholesale);
      if (b2bContainer) {
        b2bContainer.setAttribute('data-b2b-unit-price', newWholesale);
        b2bContainer.setAttribute('data-b2b-retail-price', variant.price);
      }
    }

    // Update B2B original price display if present
    var b2bOriginalDisplay = document.querySelector('[data-b2b-original-display]');
    if (b2bOriginalDisplay) {
      b2bOriginalDisplay.setAttribute('data-base-price', variant.price);
      b2bOriginalDisplay.removeAttribute('data-currency-converted');
      b2bOriginalDisplay.innerHTML = utils.formatMoney(variant.price);
    }
  };

  VariantPicker.prototype.updateMedia = function (variant) {
    if (!variant.featured_media) return;
    var gallery = this.container.querySelector('[data-gallery]');
    if (!gallery || !gallery.gallery) return;
    gallery.gallery.goToMedia(variant.featured_media.id);
  };

  VariantPicker.prototype.updateInventory = function (variant) {
    var qty = variant.inventory_quantity;
    utils.qsa('[data-inventory]', this.container).forEach(function (el) {
      var threshold = Number(el.getAttribute('data-low-threshold')) || 0;
      el.classList.remove('product-buy__inventory--in', 'product-buy__inventory--out');
      if (!variant.available) {
        el.textContent = el.getAttribute('data-text-out') || 'Out of stock';
        el.classList.add('product-buy__inventory--out');
      } else if (variant.inventory_management && variant.inventory_policy === 'deny' && threshold > 0 && qty > 0 && qty <= threshold) {
        el.textContent = utils.t(el.getAttribute('data-text-low') || 'Only {{ count }} left in stock!', { count: qty });
      } else {
        el.textContent = el.getAttribute('data-text-in') || 'In stock';
        el.classList.add('product-buy__inventory--in');
      }
    });

    // Keep the quantity input from exceeding what can actually be bought.
    utils.qsa('.qty__input', this.container).forEach(function (qtyInput) {
      if (variant.inventory_management && variant.inventory_policy === 'deny' && qty > 0) {
        qtyInput.setAttribute('max', qty);
        if (Number(qtyInput.value) > qty) qtyInput.value = qty;
      } else {
        qtyInput.removeAttribute('max');
      }
      if (L.syncQuantityButtons) {
        L.syncQuantityButtons(qtyInput.closest('[data-quantity]'));
      }
    });
  };

  VariantPicker.prototype.updateButtons = function (variant) {
    var payment = this.container.querySelector('.shopify-payment-button');
    utils.qsa('[data-add-to-cart]', this.container).forEach(function (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.setAttribute('aria-disabled', String(!variant.available));
    });
    utils.qsa('[data-add-to-cart-text]', this.container).forEach(function (addText) {
      addText.textContent = variant.available ? L.strings.addToCart : L.strings.soldOut;
    });
    if (payment) payment.hidden = !variant.available;
  };

  VariantPicker.prototype.setUnavailable = function () {
    utils.qsa('[data-add-to-cart]', this.container).forEach(function (addBtn) {
      addBtn.disabled = true;
      addBtn.setAttribute('aria-disabled', 'true');
    });
    utils.qsa('[data-add-to-cart-text]', this.container).forEach(function (addText) {
      addText.textContent = L.strings.unavailable;
    });
  };

  VariantPicker.prototype.updateSku = function (variant) {
    var el = this.container.querySelector('[data-sku]');
    if (!el) return;
    el.textContent = variant.sku || '';
    var row = el.closest('.product-info__tax');
    if (row) row.hidden = !variant.sku;
    else el.hidden = !variant.sku;
  };

  VariantPicker.prototype.updateHistory = function (variant) {
    if (!this.updateUrl || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  /* --- Gallery ------------------------------------------------------------- */

  function Gallery(el) {
    this.el = el;
    this.viewport = el.querySelector('[data-gallery-viewport]');
    this.slides = utils.qsa('[data-gallery-slide]', el);
    this.thumbs = utils.qsa('[data-gallery-thumb]', el);
    this.dots = utils.qsa('[data-gallery-dot]', el);
    this.counter = el.querySelector('[data-gallery-counter]');
    this.index = 0;

    if (!this.viewport || !this.slides.length) return;

    el.gallery = this;
    this.bind();
    this.setIndex(0);
    this.initAutoplay();
  }

  Gallery.prototype.bind = function () {
    var self = this;

    this.thumbs.forEach(function (thumb, i) {
      utils.on(thumb, 'click', function (event) {
        event.preventDefault();
        self.stopAutoplay(true);
        self.goTo(i);
      });
      utils.on(thumb, 'mouseenter', function () {
        self.goTo(i);
      });
    });

    this.dots.forEach(function (dot, i) {
      utils.on(dot, 'click', function () {
        self.stopAutoplay(true);
        self.goTo(i);
      });
    });

    utils.on(
      this.viewport,
      'scroll',
      utils.debounce(function () {
        var index = Math.round(self.viewport.scrollLeft / self.viewport.clientWidth);
        self.setIndex(index);
      }, 80),
      { passive: true }
    );

    utils.on(this.el.querySelector('[data-gallery-zoom]'), 'click', function () {
      self.stopAutoplay(true);
      self.openLightbox();
    });

    this.slides.forEach(function (slide) {
      utils.on(slide, 'click', function (event) {
        if (slide.classList.contains('gallery__slide--video')) return;
        if (event.target.closest('a, button')) return;
        self.openLightbox();
      });
    });

    this.initZoom();
  };

  Gallery.prototype.setIndex = function (index) {
    if (index < 0 || index >= this.slides.length) return;
    this.index = index;

    this.thumbs.forEach(function (thumb, i) {
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    this.dots.forEach(function (dot, i) {
      dot.setAttribute('aria-current', i === index ? 'true' : 'false');
    });

    if (this.counter) {
      this.counter.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(this.slides.length).padStart(2, '0');
    }

    // Pause any video that scrolls out of view.
    this.slides.forEach(function (slide, i) {
      var video = slide.querySelector('video');
      if (video && i !== index) video.pause();
    });
  };

  Gallery.prototype.goTo = function (index) {
    this.viewport.scrollTo({
      left: index * this.viewport.clientWidth,
      behavior: utils.prefersReducedMotion() ? 'auto' : 'smooth'
    });
    this.setIndex(index);
  };

  /**
   * Slowly cycles the gallery so the (sticky) media column keeps showing
   * something while the shopper reads the much taller info column.
   *
   * Deliberately unobtrusive: it never fights the shopper. Hover, focus and
   * touch pause it; choosing a thumbnail, opening the lightbox or picking a
   * variant stops it permanently.
   */
  Gallery.prototype.initAutoplay = function () {
    var self = this;
    var delay = parseInt(this.el.getAttribute('data-gallery-autoplay'), 10);

    this.timer = null;
    this.autoplayHalted = false;

    if (!delay || delay < 1000) return;
    if (this.slides.length < 2) return;
    if (utils.prefersReducedMotion()) return;

    this.autoplayDelay = delay;
    this.startAutoplay();

    utils.on(this.el, 'mouseenter', function () {
      self.stopAutoplay();
    });
    utils.on(this.el, 'mouseleave', function () {
      self.startAutoplay();
    });
    utils.on(this.el, 'focusin', function () {
      self.stopAutoplay();
    });
    utils.on(this.el, 'focusout', function () {
      self.startAutoplay();
    });
    utils.on(
      this.el,
      'touchstart',
      function () {
        self.stopAutoplay(true);
      },
      { passive: true }
    );

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        self.stopAutoplay();
      } else {
        self.startAutoplay();
      }
    });
  };

  Gallery.prototype.startAutoplay = function () {
    var self = this;
    if (!this.autoplayDelay || this.autoplayHalted || this.timer) return;

    this.timer = setInterval(function () {
      // Never interrupt a video the shopper is watching.
      var current = self.slides[self.index];
      var video = current && current.querySelector('video');
      if (video && !video.paused) return;

      self.goTo((self.index + 1) % self.slides.length);
    }, this.autoplayDelay);
  };

  Gallery.prototype.stopAutoplay = function (permanent) {
    if (permanent) this.autoplayHalted = true;
    if (this.timer) clearInterval(this.timer);
    this.timer = null;
  };

  Gallery.prototype.goToMedia = function (mediaId) {
    var target = -1;
    this.slides.forEach(function (slide, i) {
      if (String(slide.getAttribute('data-media-id')) === String(mediaId)) target = i;
    });
    if (target >= 0) {
      // Reached by picking a variant — rotating away from the variant's own
      // image afterwards would be actively confusing.
      this.stopAutoplay(true);
      this.goTo(target);
    }
  };

  /** Desktop hover magnifier — moves a scaled background layer with the cursor. */
  Gallery.prototype.initZoom = function () {
    if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

    utils.qsa('[data-zoom-src]', this.el).forEach(function (slide) {
      var layer = slide.querySelector('.gallery__zoom-layer');
      if (!layer) return;

      layer.style.backgroundImage = 'url(' + slide.getAttribute('data-zoom-src') + ')';
      slide.classList.add('gallery__slide--zoomable');

      utils.on(slide, 'mousemove', function (event) {
        var rect = slide.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        layer.style.backgroundPosition = x + '% ' + y + '%';
      });
    });
  };

  Gallery.prototype.openLightbox = function () {
    var lightbox = document.getElementById('ProductLightbox');
    if (!lightbox) return;

    var viewport = lightbox.querySelector('[data-lightbox-viewport]');
    if (viewport) {
      L.layers.open(lightbox, { overlay: false });
      // Jump to the slide the shopper was looking at, without animating.
      requestAnimationFrame(function () {
        viewport.scrollLeft = 0;
      });
      var self = this;
      setTimeout(function () {
        viewport.scrollTo({ left: self.index * viewport.clientWidth, behavior: 'auto' });
      }, 60);
    }
  };

  function initLightbox() {
    var lightbox = document.getElementById('ProductLightbox');
    if (!lightbox) return;

    var viewport = lightbox.querySelector('[data-lightbox-viewport]');
    var counter = lightbox.querySelector('[data-lightbox-counter]');
    var slides = utils.qsa('[data-lightbox-slide]', lightbox);
    if (!viewport || !slides.length) return;

    function update() {
      var index = Math.round(viewport.scrollLeft / viewport.clientWidth);
      if (counter) counter.textContent = index + 1 + ' / ' + slides.length;
    }

    utils.on(viewport, 'scroll', utils.throttle(update, 80), { passive: true });

    utils.on(lightbox.querySelector('[data-lightbox-prev]'), 'click', function () {
      viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
    });

    utils.on(lightbox.querySelector('[data-lightbox-next]'), 'click', function () {
      viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
    });

    document.addEventListener('keydown', function (event) {
      if (!lightbox.classList.contains('is-open')) return;
      if (event.key === 'ArrowLeft') {
        viewport.scrollBy({ left: -viewport.clientWidth, behavior: 'smooth' });
      }
      if (event.key === 'ArrowRight') {
        viewport.scrollBy({ left: viewport.clientWidth, behavior: 'smooth' });
      }
    });

    update();
  }

  /* --- Product tabs on mobile (accordion) ---------------------------------- */

  function initMobileTabs() {
    // The desktop tab panels double as accordion panels below 750px; the
    // accordion markup carries its own triggers, handled by theme.js.
    utils.qsa('[data-product-tabs]').forEach(function (group) {
      var first = group.querySelector('[role="tab"]');
      if (first && first.getAttribute('aria-selected') !== 'true') {
        first.click();
      }
    });
  }

  /* --- Recommendations ------------------------------------------------------ */

  function initRecommendations() {
    utils.qsa('[data-recommendations]').forEach(function (section) {
      var url = section.getAttribute('data-url');
      if (!url) return;

      utils
        .fetchSection(url)
        .then(function (doc) {
          var fresh = doc.querySelector('[data-recommendations]');
          if (!fresh || !fresh.querySelector('[data-product-card]')) {
            var empty = section.closest('.shopify-section');
            if (empty) empty.hidden = true;
            return;
          }
          section.innerHTML = fresh.innerHTML;
          document.dispatchEvent(
            new CustomEvent('lakshiv:section:loaded', { detail: { container: section } })
          );
          if (L.init) L.init(section);
        })
        .catch(function () {
          var wrapper = section.closest('.shopify-section');
          if (wrapper) wrapper.hidden = true;
        });
    });
  }

  /* --- Init ----------------------------------------------------------------- */

  function initBusinessPurchase(root) {
    var purchase = (root || document).querySelector('[data-business-purchase]');
    if (!purchase || purchase.__businessInit) return;
    purchase.__businessInit = true;
    var input = purchase.querySelector('#BusinessProductQuantity');
    var panel = document.querySelector('[data-b2b-panel]');
    if (!input || !panel) return;

    function rules() {
      return {
        moq: parseInt(purchase.getAttribute('data-b2b-moq'), 10) || 1,
        multiple: parseInt(purchase.getAttribute('data-b2b-pack-multiple'), 10) || 1,
        unit: parseInt(panel.getAttribute('data-b2b-unit-price'), 10) || 0,
        retail: parseInt(panel.getAttribute('data-b2b-retail-price'), 10) || 0
      };
    }

    function validate(showError) {
      var rule = rules();
      var value = parseInt(input.value, 10) || rule.moq;
      var message = '';
      if (value < rule.moq) message = 'Minimum business order is ' + rule.moq + ' units.';
      if (!message && rule.multiple > 1 && value % rule.multiple !== 0) message = 'Business quantities must be ordered in multiples of ' + rule.multiple + '.';
      var error = purchase.querySelector('[data-b2b-quantity-error]');
      if (error) {
        error.textContent = message;
        error.hidden = !(showError && message);
      }
      return !message;
    }

    function updateTotals() {
      var rule = rules();
      var quantity = parseInt(input.value, 10) || rule.moq;
      var subtotal = purchase.querySelector('[data-b2b-subtotal]');
      var savings = purchase.querySelector('[data-b2b-savings]');
      var savingsRow = purchase.querySelector('[data-b2b-savings-row]');
      if (subtotal) {
        subtotal.setAttribute('data-base-price', rule.unit * quantity);
        subtotal.removeAttribute('data-currency-converted');
        subtotal.textContent = utils.formatMoney(rule.unit * quantity);
      }
      var saved = Math.max(0, (rule.retail - rule.unit) * quantity);
      if (savingsRow) savingsRow.hidden = saved <= 0;
      if (savings) {
        savings.setAttribute('data-base-price', saved);
        savings.removeAttribute('data-currency-converted');
        savings.textContent = utils.formatMoney(saved);
      }
      validate(false);
    }

    purchase.addEventListener('click', function (event) {
      var shortcut = event.target.closest('[data-b2b-quantity]');
      if (!shortcut) return;
      input.value = shortcut.getAttribute('data-b2b-quantity');
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    input.addEventListener('input', updateTotals);
    input.addEventListener('change', updateTotals);
    input.addEventListener('blur', function () { validate(true); });

    var info = purchase.closest('[data-product-info]');
    if (info) info.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      document.querySelectorAll('.sticky-atc__btn').forEach(function (button) {
        button.disabled = !variant.available;
      });
      var stickyRetailPrice = document.querySelector('[data-sticky-retail-price]');
      if (stickyRetailPrice) {
        stickyRetailPrice.setAttribute('data-base-price', variant.price);
        stickyRetailPrice.textContent = utils.formatMoney(variant.price);
      }
      var stickyCompare = document.querySelector('[data-sticky-compare]');
      var stickyDiscount = document.querySelector('[data-sticky-discount]');
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (stickyCompare) {
        stickyCompare.hidden = !hasCompare;
        if (hasCompare) {
          stickyCompare.setAttribute('data-base-price', variant.compare_at_price);
          stickyCompare.textContent = utils.formatMoney(variant.compare_at_price);
        }
      }
      if (stickyDiscount) {
        stickyDiscount.hidden = !hasCompare;
        if (hasCompare) stickyDiscount.textContent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) + '% OFF';
      }
      var stickyBusinessPrice = document.querySelector('[data-sticky-business-price]');
      if (stickyBusinessPrice) {
        stickyBusinessPrice.setAttribute('data-base-price', Number(variant.b2b_price) || variant.price);
        stickyBusinessPrice.textContent = utils.formatMoney(Number(variant.b2b_price) || variant.price);
      }
      var moq = Number(variant.b2b_moq) || 1;
      var casePack = Math.max(moq, Number(variant.b2b_case_pack) || moq);
      var cartonPack = Math.max(moq, Number(variant.b2b_carton_pack) || moq);
      var stickyBusinessMoq = document.querySelector('.sticky-atc__business-meta span');
      if (stickyBusinessMoq) stickyBusinessMoq.textContent = 'MOQ ' + moq;
      purchase.setAttribute('data-b2b-moq', moq);
      purchase.setAttribute('data-b2b-case-pack', casePack);
      purchase.setAttribute('data-b2b-carton-pack', cartonPack);
      purchase.setAttribute('data-b2b-pack-multiple', Number(variant.b2b_pack_multiple) || 1);
      input.min = moq;
      input.step = Number(variant.b2b_pack_multiple) || 1;
      input.value = moq;
      panel.setAttribute('data-b2b-unit-price', Number(variant.b2b_price) || variant.price);
      panel.setAttribute('data-b2b-retail-price', variant.price);
      var shortcuts = purchase.querySelectorAll('[data-b2b-quantity]');
      [moq, casePack, cartonPack].forEach(function (value, index) {
        if (shortcuts[index]) {
          shortcuts[index].setAttribute('data-b2b-quantity', value);
          shortcuts[index].textContent = (index === 0 ? 'MOQ · ' : index === 1 ? 'Case · ' : 'Carton · ') + value;
        }
      });
      var moqProperty = document.querySelector('#BusinessProductForm [name="properties[_b2b_moq]"]');
      var multipleProperty = document.querySelector('#BusinessProductForm [name="properties[_b2b_pack_multiple]"]');
      if (moqProperty) moqProperty.value = moq;
      if (multipleProperty) multipleProperty.value = Number(variant.b2b_pack_multiple) || 1;
      updateTotals();
    });
    updateTotals();
  }

  function init(root) {
    utils.qsa('[data-product-info]', root).forEach(function (el) {
      if (el.__variantInit) return;
      el.__variantInit = true;
      new VariantPicker(el);
    });

    utils.qsa('[data-gallery]', root).forEach(function (el) {
      if (el.__galleryInit) return;
      el.__galleryInit = true;
      new Gallery(el);
    });

    initBusinessPurchase(root);

    if (!root) {
      initLightbox();
      initMobileTabs();
      initRecommendations();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Quick view injects a full product form — wire it up when it lands.
  document.addEventListener('lakshiv:section:loaded', function (event) {
    var root = event.detail && event.detail.container;
    if (root) init(root);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
